const getHashCode = (value) => {
  var hash = 0;
  if (value.length === 0) return hash;
  for (var i = 0; i < value.length; i++) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash; // Convert to 32bit integer
  }
  return intToHSL(hash);
};

const intToHSL = (value) => {
  var shortened = value % 360;
  return "hsl(" + shortened + ", 100%, 30%)";
};

export default {
  /**
   * @param {State} state
   * @param {Array<Timeline>} payload
   */
  SET_TIMELINE(state, payload) {
    state.timelines = payload;
  },

  /**
   * @param {State} state
   * @param {Array<Motion>} payload
   */
  SET_MOTIONS(state, payload) {
    state.motions = payload;
  },
  /**
   * @param {State} state
   * @param {Array<ColorUrl>} payload
   */
   SET_TIMELINE_HISTORY(state, payload) {
    let colorUrls = []
    if (payload !== undefined) {
      payload.map(item => {
        colorUrls.push({
          name: item.server_name,
          fromTs: item.from_timestamp,
          toTs: item.to_timestamp === undefined ? Date.now() / 1000 : item.to_timestamp,
          color: getHashCode(item.server_name)
        })
      })
    }
    state.colorUrls = colorUrls
  },
};

/**
 * @typedef State
 * @property {Array<Timeline>} timelines
 * @property {Array<Motion>} motions
 * @property {Array<ColorUrl>} colorUrls
 */

/**
 * @typedef Timeline
 * @property {Number} start
 * @property {Number} duration
 * @property {String} stream
 */

/**
 * @typedef Motion
 * @property {Number} start
 * @property {Number} duration
 */

/**
 * @typedef ColorUrl
 * @property {String} name
 * @property {String} fromTs
 * @property {String} toTs
 */
